import { type MapBounds } from '@/packages/redux-state/store/slices/mapConfiguration/slice';

import { convertMapBoundsToBbox } from './convertMapBoundsToBbox';

export const convertMapBoundsToJsonQueryBbox = (
  bounds: MapBounds,
): [[lngMax: number, latMin: number], [lngMin: number, latMax: number]] => {
  const { topLeft, bottomRight } = convertMapBoundsToBbox(bounds);

  return [
    [topLeft.lng, topLeft.lat],
    [bottomRight.lng, bottomRight.lat],
  ] as [[lngMax: number, latMin: number], [lngMin: number, latMax: number]];
};
